<template>

    <font-awesome-icon :icon="icon" :class="icon" />

</template>

<script>
    export default {
        name: 'FaIcon',
        props: ['name'],
        data(){
            return {
                icon : ['fal', this.name],
            }
        }
    };
</script>xz

<style scoped lang="scss">

</style>